


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Audit, Vat } from '@/api';
import { vatAuditsTableFields } from './models/vat-audits-table-fields';

@Component({})
export default class MilkVatOffsetChangeLog extends Vue {
	@Prop({ required: true, type: Object })
	private vat!: Vat & { audits: Audit[] };

	public get audits(): Audit[] {
		return this.vat.audits.filter((audit: Audit) => {
			const fields: string = audit.fields ?? '';
			return fields.includes('vatOffset') || fields.includes('calibratedAt');
		});
	}

	public get auditFields(): { key: string; label: string }[] {
		return vatAuditsTableFields;
	}
}
